import React from "react";
import ApprovalScope from "./ApprovalScope";
import hero3 from "../image/interior-bg1.png";
import hero5 from "../image/interior-bg1.png";
import Footer from "../components/Footer";
import {
  FaUserCheck,
  FaLightbulb,
  FaCube,
  FaCouch,
  FaPalette,
  FaTools
} from "react-icons/fa";

const interiorData = [
  {
    id: "01",
    icon: <FaUserCheck />,
    title: "Client Requirement & Lifestyle Study",
    desc: "Understanding client needs, lifestyle patterns, and functional requirements.",
  },
  {
    id: "02",
    icon: <FaLightbulb />,
    title: "Concept Theme & Layout Planning",
    desc: "Developing the overall design theme along with space planning and layout.",
  },
  {
    id: "03",
    icon: <FaCube />,
    title: "3D Visualization & Design Finalization",
    desc: "Detailed 3D views to finalize the design before execution.",
  },
  {
    id: "04",
    icon: <FaCouch />,
    title: "Furniture & Modular Design",
    desc: "Custom furniture design along with modular solutions including kitchens and wardrobes.",
  },
  {
    id: "05",
    icon: <FaPalette />,
    title: "Material & Finish Selection",
    desc: "Selection of materials, finishes, and color palettes to define the space.",
  },
  {
    id: "06",
    icon: <FaTools />,
    title: "On-Site Execution & Coordination",
    desc: "Execution with skilled teams and coordination on site to ensure design accuracy.",
  },
];

export default function Interior({openContactModal, showCTA }) {
  return (

    <div>

    <ApprovalScope
      heroTitle={`Interior Design for Complete Homes`}
      heroSubtitle="Thoughtfully designed interiors that balance comfort, function, and elegance.
"
  heroImg={hero3}
   heroBg={hero5}

    //   sectionTitle="Interior Design for Complete Homes"

    topText={
  <>
    At Dwellora, interiors are developed alongside architecture to create seamless living environments. We specialize in custom furniture design and modular solutions, including modern kitchens with built-in appliances.
    <br />
    With 10+ years of experience, our process begins by understanding your lifestyle, preferences, and space requirements. We then develop 3D visualizations based on your inputs and references. Once finalized, execution is carried out with our skilled team, ensuring quality and design consistency.
  </>
}

      heading="Detailed Interior Scope"

      data={interiorData}

      ctaTitle="Building Approvals & Permissions"
      ctaDesc="Dwellora manages the entire building permission process across PMC, PCMC, and PMRDA jurisdictions."

      ctaBtn="Let’s Consult"
  openContactModal={openContactModal}

    />

     <Footer 
  openContactModal={openContactModal}
  showCTA={showCTA} 
/>

</div>
    
  );
}